// extracted by mini-css-extract-plugin
module.exports = {"button":"BorderButton_button__28CKj","touch":"BorderButton_touch__XXSAV","count":"BorderButton_count__38HzV"};